import './firebase-app';
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions';

const functions = getFunctions();
functions.region = 'europe-west1';

if (import.meta.env.DEV && import.meta.env.VITE_FUNCTIONS_PORT)
  connectFunctionsEmulator(
    functions,
    'localhost',
    +import.meta.env.VITE_FUNCTIONS_PORT,
  );
